export default "__VITE_ASSET__ab4b520f__"